const ENVIRONMENT_URLS_AUTHOR: Record<string, { base: string; dam: string }> = {
	local: {
		base: process.env.ENV_LOCAL_MGNL_BASE_AUTHOR_URL || '',
		dam: process.env.ENV_LOCAL_MGNL_BASE_DAM_AUTHOR_URL || '',
	},
	sandbox: {
		base: process.env.ENV_SANDBOX_MGNL_BASE_AUTHOR_URL || '',
		dam: process.env.ENV_SANDBOX_MGNL_BASE_DAM_AUTHOR_URL || '',
	},
	testing: {
		base: process.env.ENV_TESTING_MGNL_BASE_AUTHOR_URL || '',
		dam: process.env.ENV_TESTING_MGNL_BASE_DAM_AUTHOR_URL || '',
	},
	production: {
		base: process.env.ENV_PRODUCTION_MGNL_BASE_AUTHOR_URL || '',
		dam: process.env.ENV_PRODUCTION_MGNL_BASE_DAM_AUTHOR_URL || '',
	},
};

const ENVIRONMENT_URLS_PUBLIC: Record<string, { base: string; dam: string }> = {
	local: {
		base: process.env.ENV_LOCAL_MGNL_BASE_PUBLIC_URL || '',
		dam: process.env.ENV_LOCAL_MGNL_BASE_DAM_PUBLIC_URL || '',
	},
	sandbox: {
		base: process.env.ENV_SANDBOX_MGNL_BASE_PUBLIC_URL || '',
		dam: process.env.ENV_SANDBOX_MGNL_BASE_DAM_PUBLIC_URL || '',
	},
	testing: {
		base: process.env.ENV_TESTING_MGNL_BASE_PUBLIC_URL || '',
		dam: process.env.ENV_TESTING_MGNL_BASE_DAM_PUBLIC_URL || '',
	},
	production: {
		base: process.env.ENV_PRODUCTION_MGNL_BASE_PUBLIC_URL || '',
		dam: process.env.ENV_PRODUCTION_MGNL_BASE_DAM_PUBLIC_URL || '',
	},
};

const getMagnoliaEnvironmentOverride = (): string | null => {
	const url = new URL(window.location.href);
	if (url.searchParams.has('environment')) {
		const magnoliaEnvironmentParam = url.searchParams.get('environment')?.trim().toLowerCase();
		const storedOverride = sessionStorage.getItem('environmentOverride');
		
		if (magnoliaEnvironmentParam) {
			// Store the override in sessionStorage
			if (magnoliaEnvironmentParam !== storedOverride) {
				sessionStorage.setItem('environmentOverride', magnoliaEnvironmentParam);
				console.log(`Environment override set to: ${magnoliaEnvironmentParam}`);
			}
			return magnoliaEnvironmentParam;
		} else {
			// Remove the override if parameter is empty
			if (storedOverride) {
				sessionStorage.removeItem('environmentOverride');
				console.log('Environment override cleared');
			}
			return null;
		}
	}
	return sessionStorage.getItem('environmentOverride');
};

export const getMagnoliaBaseUrl = () => {
	const override = getMagnoliaEnvironmentOverride();
	if (override) {
		// Check if it's a known environment
		const envUrls = isCmsPreview() ? ENVIRONMENT_URLS_AUTHOR : ENVIRONMENT_URLS_PUBLIC;
		if (override in envUrls) {
			return envUrls[override].base;
		}
		// Otherwise treat it as a direct URL
		return override;
	}
	const magnoliaBaseUrl = isCmsPreview()
		? process.env.MGNL_BASE_AUTHOR_URL
		: process.env.MGNL_BASE_PUBLIC_URL;
	return magnoliaBaseUrl;
};

export const getMagnoliaBaseDamUrl = () => {
	const override = getMagnoliaEnvironmentOverride();
	if (override) {
		// Check if it's a known environment
		const envUrls = isCmsPreview() ? ENVIRONMENT_URLS_AUTHOR : ENVIRONMENT_URLS_PUBLIC;
		if (override in envUrls) {
			return envUrls[override].dam;
		}
		// Otherwise treat it as a direct URL
		return override;
	}
	const magnoliaBaseDamUrl = isCmsPreview()
		? process.env.MGNL_BASE_DAM_AUTHOR_URL
		: process.env.MGNL_BASE_DAM_PUBLIC_URL;
	return magnoliaBaseDamUrl;
};

const CMS_PREVIEW_KEY = 'cmsPreview';
export function isCmsPreview(): boolean {
	const url = new URL(window.location.href);

	if (url.searchParams.has(CMS_PREVIEW_KEY)) {
		const previewParam = url.searchParams
			.get(CMS_PREVIEW_KEY)
			?.toLocaleLowerCase();
		const previewing = sessionStorage.getItem(CMS_PREVIEW_KEY);
		switch (previewParam) {
			case 'true':
			case '1':
			case '':
			case null:
				sessionStorage.setItem(CMS_PREVIEW_KEY, 'true');
				if (!previewing) {
					console.log('CMS Preview mode enabled');
				}
				break;
			case 'false':
			case '0':
				sessionStorage.removeItem(CMS_PREVIEW_KEY);
				if (previewing) {
					console.log('CMS Preview mode disabled');
				}
				break;
		}
	}

	return sessionStorage.getItem(CMS_PREVIEW_KEY) === 'true';
}

const APP_BASE_KEY = 'appBase';
export function getAppBase() {
	const url = new URL(window.location.href);

	if (url.searchParams.has(APP_BASE_KEY)) {
		const appBaseParam = url.searchParams.get(APP_BASE_KEY)?.trim();
		const storedAppBase = sessionStorage.getItem(APP_BASE_KEY);

		if (appBaseParam !== storedAppBase) {
			if (appBaseParam) {
				const normalizedAppBase = appBaseParam.startsWith('/')
					? appBaseParam
					: `/${appBaseParam}`;
				sessionStorage.setItem(APP_BASE_KEY, normalizedAppBase);
				console.log(`App base set to ${normalizedAppBase}`);
			} else {
				sessionStorage.removeItem(APP_BASE_KEY);
				console.log('App base reset to default');
			}
		}
	}

	return (
		sessionStorage.getItem('appBase') || process.env.MGNL_PAGES_APP_BASE || ''
	);
}
